import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ChatProvider } from "./context/chatcontext";
import { AuthProvider } from "./context/authContext";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "light",
    background: { default: "#FFFFFF", paper: "#F0F8FF" }, // White and AliceBlue (a very light skyblue)
    primary: { main: "#87CEEB" }, // SkyBlue
    text: { primary: "#000000" },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <ChatProvider>
          <App />
        </ChatProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
